// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C08: public contract and supplier acceptance, including the signed record. */
.rcti-supplier-page .rcti-agreements__content {
  max-width: 1600px;
  margin: auto;
  padding: var(--space-8);
}
.rcti-supplier-page .rcti-public-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.rcti-supplier-page .agreement-supplier-document {
  grid-column: 1;
  grid-row: 1 / span 6;
}
.rcti-supplier-page .agreement-review-paper {
  padding: var(--space-6);
}
.supplier-document-brand-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}
.rcti-supplier-page .agreement-review-document-heading h2 {
  font-size: var(--font-size-h3);
  line-height: 1.3;
}
.rcti-supplier-page .agreement-review-parties {
  margin: var(--space-6) 0;
}
.rcti-supplier-page .agreement-review-parties p {
  overflow-wrap: anywhere;
}
.supplier-contract-status {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
}
.supplier-contract-facts {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: var(--space-4);
  padding: var(--space-5) 0;
  border-block: 1px solid var(--border-subtle);
  margin: 0 0 var(--space-6);
  font-size: var(--font-size-body-sm);
}
.supplier-contract-facts dt {
  color: var(--text-secondary);
}
.supplier-contract-facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.supplier-signing-sidebar {
  grid-column: 2;
  grid-row: 1;
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.supplier-signing-sidebar form,
.supplier-before-accept {
  display: grid;
  gap: var(--space-4);
  padding: var(--space-6);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
}
.rcti-supplier-page .supplier-signing-sidebar h2,
.rcti-supplier-page .rcti-public-controls h2 {
  margin: 0;
  font-size: var(--font-size-body-lg);
}
.rcti-supplier-page .supplier-signing-sidebar p,
.rcti-supplier-page .rcti-public-controls p {
  margin: 0;
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
  color: var(--text-secondary);
}
.rcti-supplier-page .supplier-signing-sidebar label {
  font-size: var(--font-size-body-sm);
  line-height: 1.5;
}
.rcti-supplier-page .supplier-signing-sidebar .rcti-consent {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}
.rcti-supplier-page .rcti-consent input {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin-top: 3px;
}
.rcti-supplier-page .agreement-clause p {
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.rcti-supplier-page .agreement-clause h3 {
  font-size: var(--font-size-body-sm);
}
@media (max-width: 1100px) {
  .rcti-supplier-page .rcti-public-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-supplier-page .agreement-supplier-document,
  .supplier-signing-sidebar,
  .rcti-supplier-page .rcti-public-controls {
    grid-column: 1;
    grid-row: auto;
  }
}
@media (max-width: 600px) {
  .rcti-supplier-page .rcti-agreements__content {
    padding: var(--space-4);
  }
  .supplier-contract-facts {
    grid-template-columns: 1fr;
    gap: var(--space-2);
  }
  .supplier-contract-facts dd {
    margin-bottom: var(--space-3);
  }
  .rcti-supplier-page .agreement-review-paper,
  .supplier-signing-sidebar form,
  .supplier-before-accept {
    padding: var(--space-4);
  }
}
@media print {
  .supplier-signing-sidebar {
    display: none !important;
  }
  .rcti-supplier-page .rcti-public-workspace {
    display: block;
  }
}
.rcti-supplier-page .rcti-agreement-signing-intro {
  padding-top: 0;
  border-top: 0;
}
.supplier-invitation-page {
  display: grid;
  gap: var(--space-6);
}
.supplier-invitation-card {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: var(--space-8);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.rcti-supplier-page .supplier-invitation-card p {
  margin: 0;
  line-height: 1.75;
  font-size: var(--font-size-body-sm);
  overflow-wrap: anywhere;
}
.supplier-invitation-card h2 {
  margin: 0;
  font-size: var(--font-size-h2);
}
.supplier-invitation-envelope {
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);
  gap: var(--space-4);
  padding: 0 0 var(--space-6);
  margin: 0;
  border-bottom: 1px solid var(--border-subtle);
  font-size: var(--font-size-body-sm);
}
.supplier-invitation-envelope dt {
  color: var(--text-secondary);
}
.supplier-invitation-envelope dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.supplier-invitation-summary {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-5);
  background: var(--surface-secondary);
  border-radius: var(--radius-md);
  justify-items: start;
}
.supplier-invitation-card footer {
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
  line-height: 1.65;
}
@media (max-width: 600px) {
  .supplier-invitation-card {
    padding: var(--space-5);
  }
}
.rcti-supplier-page .supplier-invitation-card p {
  color: var(--text-primary);
}
.rcti-supplier-page .supplier-invitation-card .agreement-review-brand {
  color: var(--interactive-default);
  font-weight: var(--font-weight-medium);
}
.supplier-invitation-card h2 {
  font-weight: var(--font-weight-medium);
}

/* Keep both parties' signature records together on the contract. */
.supplier-signature-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.supplier-signature-columns > section {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}
.supplier-signature-columns img {
  max-width: 100%;
  height: auto;
}
@media (max-width: 600px) {
  .supplier-signature-columns {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Share row heights so acknowledgements, drawings and timestamps line up. */
.supplier-signature-columns { align-items: stretch; }
.supplier-signature-columns > .agreement-review-acknowledgement {
  grid-template-rows: auto 1fr auto auto;
}
.supplier-signature-columns .rcti-saved-signature img {
  width: 100%;
  height: 100px;
  object-fit: contain;
  object-position: center;
}
@supports (grid-template-rows: subgrid) {
  .supplier-signature-columns > .agreement-review-acknowledgement {
    grid-row: span 4;
    grid-template-rows: subgrid;
  }
}
@media (max-width: 600px) {
  .supplier-signature-columns > .agreement-review-acknowledgement {
    grid-row: auto;
    grid-template-rows: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/supplierAgreement.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;;EAEE,SAAS;EACT,mCAAmC;AACrC;AACA;;EAEE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,qCAAqC;EACvC;EACA;;;IAGE,cAAc;IACd,cAAc;EAChB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;;;IAGE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;EACtC,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA,4EAA4E;AAC5E,8BAA8B,oBAAoB,EAAE;AACpD;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,cAAc;IACd,wBAAwB;EAC1B;AACF","sourcesContent":["/* C08: public contract and supplier acceptance, including the signed record. */\n.rcti-supplier-page .rcti-agreements__content {\n  max-width: 1600px;\n  margin: auto;\n  padding: var(--space-8);\n}\n.rcti-supplier-page .rcti-public-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.rcti-supplier-page .agreement-supplier-document {\n  grid-column: 1;\n  grid-row: 1 / span 6;\n}\n.rcti-supplier-page .agreement-review-paper {\n  padding: var(--space-6);\n}\n.supplier-document-brand-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n}\n.rcti-supplier-page .agreement-review-document-heading h2 {\n  font-size: var(--font-size-h3);\n  line-height: 1.3;\n}\n.rcti-supplier-page .agreement-review-parties {\n  margin: var(--space-6) 0;\n}\n.rcti-supplier-page .agreement-review-parties p {\n  overflow-wrap: anywhere;\n}\n.supplier-contract-status {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip-path: inset(50%);\n}\n.supplier-contract-facts {\n  display: grid;\n  grid-template-columns: 140px minmax(0, 1fr);\n  gap: var(--space-4);\n  padding: var(--space-5) 0;\n  border-block: 1px solid var(--border-subtle);\n  margin: 0 0 var(--space-6);\n  font-size: var(--font-size-body-sm);\n}\n.supplier-contract-facts dt {\n  color: var(--text-secondary);\n}\n.supplier-contract-facts dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.supplier-signing-sidebar {\n  grid-column: 2;\n  grid-row: 1;\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.supplier-signing-sidebar form,\n.supplier-before-accept {\n  display: grid;\n  gap: var(--space-4);\n  padding: var(--space-6);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n}\n.rcti-supplier-page .supplier-signing-sidebar h2,\n.rcti-supplier-page .rcti-public-controls h2 {\n  margin: 0;\n  font-size: var(--font-size-body-lg);\n}\n.rcti-supplier-page .supplier-signing-sidebar p,\n.rcti-supplier-page .rcti-public-controls p {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n  color: var(--text-secondary);\n}\n.rcti-supplier-page .supplier-signing-sidebar label {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.5;\n}\n.rcti-supplier-page .supplier-signing-sidebar .rcti-consent {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n.rcti-supplier-page .rcti-consent input {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  margin-top: 3px;\n}\n.rcti-supplier-page .agreement-clause p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.rcti-supplier-page .agreement-clause h3 {\n  font-size: var(--font-size-body-sm);\n}\n@media (max-width: 1100px) {\n  .rcti-supplier-page .rcti-public-workspace {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-supplier-page .agreement-supplier-document,\n  .supplier-signing-sidebar,\n  .rcti-supplier-page .rcti-public-controls {\n    grid-column: 1;\n    grid-row: auto;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-supplier-page .rcti-agreements__content {\n    padding: var(--space-4);\n  }\n  .supplier-contract-facts {\n    grid-template-columns: 1fr;\n    gap: var(--space-2);\n  }\n  .supplier-contract-facts dd {\n    margin-bottom: var(--space-3);\n  }\n  .rcti-supplier-page .agreement-review-paper,\n  .supplier-signing-sidebar form,\n  .supplier-before-accept {\n    padding: var(--space-4);\n  }\n}\n@media print {\n  .supplier-signing-sidebar {\n    display: none !important;\n  }\n  .rcti-supplier-page .rcti-public-workspace {\n    display: block;\n  }\n}\n.rcti-supplier-page .rcti-agreement-signing-intro {\n  padding-top: 0;\n  border-top: 0;\n}\n.supplier-invitation-page {\n  display: grid;\n  gap: var(--space-6);\n}\n.supplier-invitation-card {\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  padding: var(--space-8);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.rcti-supplier-page .supplier-invitation-card p {\n  margin: 0;\n  line-height: 1.75;\n  font-size: var(--font-size-body-sm);\n  overflow-wrap: anywhere;\n}\n.supplier-invitation-card h2 {\n  margin: 0;\n  font-size: var(--font-size-h2);\n}\n.supplier-invitation-envelope {\n  display: grid;\n  grid-template-columns: 70px minmax(0, 1fr);\n  gap: var(--space-4);\n  padding: 0 0 var(--space-6);\n  margin: 0;\n  border-bottom: 1px solid var(--border-subtle);\n  font-size: var(--font-size-body-sm);\n}\n.supplier-invitation-envelope dt {\n  color: var(--text-secondary);\n}\n.supplier-invitation-envelope dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.supplier-invitation-summary {\n  display: grid;\n  gap: var(--space-3);\n  padding: var(--space-5);\n  background: var(--surface-secondary);\n  border-radius: var(--radius-md);\n  justify-items: start;\n}\n.supplier-invitation-card footer {\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-subtle);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n  line-height: 1.65;\n}\n@media (max-width: 600px) {\n  .supplier-invitation-card {\n    padding: var(--space-5);\n  }\n}\n.rcti-supplier-page .supplier-invitation-card p {\n  color: var(--text-primary);\n}\n.rcti-supplier-page .supplier-invitation-card .agreement-review-brand {\n  color: var(--interactive-default);\n  font-weight: var(--font-weight-medium);\n}\n.supplier-invitation-card h2 {\n  font-weight: var(--font-weight-medium);\n}\n\n/* Keep both parties' signature records together on the contract. */\n.supplier-signature-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.supplier-signature-columns > section {\n  min-width: 0;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.supplier-signature-columns img {\n  max-width: 100%;\n  height: auto;\n}\n@media (max-width: 600px) {\n  .supplier-signature-columns {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n/* Share row heights so acknowledgements, drawings and timestamps line up. */\n.supplier-signature-columns { align-items: stretch; }\n.supplier-signature-columns > .agreement-review-acknowledgement {\n  grid-template-rows: auto 1fr auto auto;\n}\n.supplier-signature-columns .rcti-saved-signature img {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  object-position: center;\n}\n@supports (grid-template-rows: subgrid) {\n  .supplier-signature-columns > .agreement-review-acknowledgement {\n    grid-row: span 4;\n    grid-template-rows: subgrid;\n  }\n}\n@media (max-width: 600px) {\n  .supplier-signature-columns > .agreement-review-acknowledgement {\n    grid-row: auto;\n    grid-template-rows: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
